import { render } from "./ButtonAdminPanel.vue?vue&type=template&id=0bd6a0b8&scoped=true"
import script from "./ButtonAdminPanel.vue?vue&type=script&lang=js"
export * from "./ButtonAdminPanel.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./ButtonAdminPanel.vue?vue&type=style&index=1&id=0bd6a0b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd6a0b8"]])

export default __exports__